function attachGauthClickHandler() {
    if (window.google) {
        let element = document.getElementById('g_id_signin');
        if (element && window.google.accounts) {
            window.google.accounts.id.renderButton(element, {});
        }
    }
}

function handleGoogleSignIn(response) {
    game.services.user.login('google', {
        token: response.credential
    }, this);
}

loadScript('https://accounts.google.com/gsi/client', () => {
    if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
            client_id: '773830838234-5jiv3cbb2hibmg21feg9iabjdo8f8v9n.apps.googleusercontent.com',
            callback: handleGoogleSignIn,
            ux_mode: 'popup'
        });
    }
});

Vue.component('state-signin', {
    mounted: function() {
        attachGauthClickHandler();
    },
    data: function() {
        return {
            loading: false,
            email: '',
            password: ''
        };
    },
    methods: {
        submit: function(e) {
            e.preventDefault();
            //game.playSound('button_click');
            this.loading = true;
            game.services.user.login('bsg', {
                email: this.email,
                password: this.password
            }, this).then(() => {
                //this.loading = false;
            }, () => {
                this.loading = false;
            });
        },
        register: function() {
            //game.playSound('button_click');
            this.$root.$emit('changeState', 'state-register');
        },
        bmc: function() {
            //game.playSound('button_click');
        },
        bme: function() {
            //game.playSound('button_hover');
        }
    },
    template: `
    <div class="vertical-center">
        <div v-if="loading">
            <h1><i class="fa fa-refresh fa-spin fa-2x"></i></h1>
        </div>
        <div v-if="!loading">
            <h2>Sign in to earn XP and unlock items for free!</h2>
            <br>
            <div id="g_id_signin" data-type="standard" @mouseenter="bme" v-on:click="bmc">
                <i class="fa fa-google"></i>&nbsp;&nbsp;Sign In with Google
            </div>
            <br><br>
            <h2>Or</h2>
            <br>
            <div class="app-card text-center">
                <form @submit="submit">
                    <h1><i class="fa fa-sign-in"></i> Sign In</h1>
                    <label class="text-left">
                        Email
                        <input v-model="email" required="required" type="email" class="app-input" placeholder="Email">
                    </label>
                    <br>
                    <label class="text-left">
                        Password
                        <input v-model="password" required="required" type="password" class="app-input" placeholder="Password">
                    </label>
                    <br><br>
                    <button type="submit" class="app-btn app-btn-secondary btn-sm" @mouseenter="bme">
                        <i class="fa fa-sign-in"></i> Submit
                    </button>
                </form>
            </div>
            <br><br>
            <h3>Don't have an account?</h3>
            <button type="button" class="app-btn app-btn-secondary btn-sm" @mouseenter="bme" v-on:click="register">
                <i class="fa fa-user"></i> Register
            </button>
        </div>
    </div>
    `
})